export const MAX_GUESSES = 5;
export const ALERT_TIME_MS = 2000;
export const REVEAL_TIME_MS = 350;
export const WELCOME_INFO_MODAL_MS = 350;
export const MAX_WISHES = 1;
export const BOOK_RESET_NUMBER = 59;
